module.exports = __webpack_public_path__ + "img/ant.e237f295.svg";